module.exports = __webpack_public_path__ + "static/img/visual.a85fb40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Top/visual.svg
// module id = MkoA
// module chunks = 0